import { useEffect } from "react";
import { Typography, Box, Grid, Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { CouponTemplateFormDto } from "../../../store/models/coupon/CouponManagementDto";
import { thunkGetOperationalUnits } from "../../../store/actions/OperationalUnitActions";
import { IStore } from "../../../store/IStore";
import OperationalUnitsSelector from "../OperationalUnitsSelector";

interface CouponOperationalUnitsStepProps {
  formData: CouponTemplateFormDto;
  updateFormData: (updates: Partial<CouponTemplateFormDto>) => void;
  readOnly?: boolean;
}

const CouponOperationalUnitsStep = ({
  formData,
  updateFormData,
  readOnly = false,
}: CouponOperationalUnitsStepProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const operationalUnits = useSelector((state: IStore) => state.operationalUnits?.operationalUnits || []);
  const loading = false; // Loading state not available in this reducer

  useEffect(() => {
    dispatch(thunkGetOperationalUnits() as any);
  }, [dispatch]);

  const handleSelectionChange = (selectedUnits: string[]) => {
    updateFormData({
      operationalUnitNumbers: selectedUnits,
    });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold", color: "#3859ff" }}>
        {t("coupon.form.redeemableAt")}
      </Typography>

      <Alert severity="warning">
        <strong>Note:</strong> If no specific unit is selected below, the coupon will be redeemable everywhere.
      </Alert>

      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <OperationalUnitsSelector
            operationalUnits={operationalUnits}
            selectedUnits={formData.operationalUnitNumbers || []}
            onSelectionChange={handleSelectionChange}
            loading={loading}
            disabled={readOnly}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CouponOperationalUnitsStep;
